module.exports = "/_next/static/images/ribbon-monotone-f5219d19bd7eda99a7a71686f326ea02.svg";